import { render, staticRenderFns } from "./AddNewInstrument.vue?vue&type=template&id=df9a83f2&"
import script from "./AddNewInstrument.vue?vue&type=script&lang=js&"
export * from "./AddNewInstrument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports